import React from "react"
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from "gatsby"
import useSectionData from "../static_queries/useSectionData"
import Scrollspy from "react-scrollspy";
import DownloadData from "./download-data"
export default function AsideNavigation(props) {
  const allSectionData = useSectionData();

  function handleClick() {
    props.isLinkClicked(true)
  }

  return (
    <StaticQuery
      query={graphql`
        {
          file(sourceInstanceName: {eq: "settings"}, name: {eq: "section-order"}) {
            id
            name
            childMarkdownRemark {
              html
              frontmatter {
                sections
              }
            }
          }
        }
      `}
      render={data => {
        const sectionIds = data.file.childMarkdownRemark.frontmatter.sections.map(section => section.slice(0, -3).replace('content/sections/',''))

        return (
          <aside className={`menu ${props.isSticky ? 'is-sticky' : 'is-mobile'} aside-navigation`}>
            <Scrollspy
              items={ sectionIds }
              currentClassName="is-active"
              scrolledPastClassName="is-scrolled-past"
              className="menu-list"
            >
              {data.file.childMarkdownRemark.frontmatter.sections.map(section => {
                const sectionID = section.slice(0, -3)
                return(
                  <li key={section}>
                    {allSectionData.allFile.edges.map(allSectionDatum => {
                      if (`content/sections/${allSectionDatum.node.name}` === sectionID) {
                        return (
                          <a key={allSectionDatum.node.name} href={`#${allSectionDatum.node.name}`} onClick={handleClick}>{allSectionDatum.node.childMarkdownRemark.frontmatter.title}</a>
                        )
                      }
                    })}
                  </li>
                )
              })}
            </Scrollspy>
            <DownloadData />
          </aside>
        )
      }}
    ></StaticQuery>
  )
}

AsideNavigation.defaultProps = {
  isSticky: false,
  isLinkClicked: false,
}

AsideNavigation.propTypes = {
  isSticky: PropTypes.bool,
  isLinkClicked: PropTypes.func
}

